import { GeojsonCoordinate } from '../utils/genjson'
import { getRoot } from '/@/root'

export function useMouseTool () {
  const root = getRoot() as any
  const L = root.$leaflet

  function mouseTool (type: string, callback: Function, flightAreaType?: any) {
    // Wait for map to be available
    const waitForMap = () => {
      const map = root.$map
      const drawControl = root.$drawControl
      if (!map || !drawControl) {
        setTimeout(waitForMap, 100) // Poll every 100ms
        return
      }

      if (type === 'off') {
        // Disable drawing mode - close any active drawing
        if (drawControl._toolbars && drawControl._toolbars.draw) {
          drawControl._toolbars.draw._modes.marker.handler.disable()
          drawControl._toolbars.draw._modes.polyline.handler.disable()
          drawControl._toolbars.draw._modes.polygon.handler.disable()
          drawControl._toolbars.draw._modes.circle.handler.disable()
        }
        return
      }

      // Set up the callback for when drawing is completed
      const handleDrawCreated = (e: any) => {
        const layer = e.layer
        const extData = {
          type: type,
          mapType: type === 'circle' ? 'circle' : type === 'polygon' ? 'polygon' : type
        }
        layer.options.extData = extData

        callback(null, { obj: layer })

        // Remove the event listener to avoid duplicates
        map.off('draw:created', handleDrawCreated)
      }

      // Listen for draw completion
      map.on('draw:created', handleDrawCreated)

      // Activate the appropriate drawing mode
      if (drawControl._toolbars && drawControl._toolbars.draw) {
        const drawToolbar = drawControl._toolbars.draw

        // Disable all modes first
        drawToolbar._modes.marker.handler.disable()
        drawToolbar._modes.polyline.handler.disable()
        drawToolbar._modes.polygon.handler.disable()
        drawToolbar._modes.circle.handler.disable()

        // Enable the selected mode
        switch (type) {
          case 'pin':
            drawToolbar._modes.marker.handler.enable()
            break
          case 'polyline':
            drawToolbar._modes.polyline.handler.enable()
            break
          case 'polygon':
            drawToolbar._modes.polygon.handler.enable()
            break
          case 'circle':
            drawToolbar._modes.circle.handler.enable()
            break
        }
      }
    }

    waitForMap()
  }

  return {
    mouseTool
  }
}
